module.exports = __webpack_public_path__ + "img/bg-getmx.d457fbfb.jpg";